import dynamicImport from 'components/dynamicImport';
import React, { Component } from 'react';
import RoundDurationEditDefault from './RoundDurationEditDefault';

const RoundDurationEditContent = dynamicImport({
  component: '/containers/Sale/RoundSection/RoundDurationEdit',
  fallback: RoundDurationEditDefault,
});
class RoundDurationEdit extends Component {
  render() {
    return <RoundDurationEditContent {...this.props} />;
  }
}

export default RoundDurationEdit;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/RoundSection/RoundDurationEdit.jsx